import React from "react"
import { ActionIcon, Box, CopyButton, Divider, Tooltip, useMantineTheme } from "@mantine/core"

import {
    ThumbsUpFarFAIcon,
    ThumbsDownFarFAIcon,
    CopyFarFAIcon,
    CheckFarFAIcon,
} from "@quorumus/plum/dist/components/Icons"

import classes from "./FeedbackActions.module.css"

interface Props {
    summary: string
    billId: string
    profileId: string
    onFeedbackClick: (type: "positive" | "negative") => void
    selectedFeedback: "positive" | "negative" | null
}

export const FeedbackActions = (props: Props) => {
    const theme = useMantineTheme()

    const handleFeedbackClick = (type: "positive" | "negative") => {
        props.onFeedbackClick(type)
    }

    return (
        <Box className={classes.messageActionsWrapper}>
            <Tooltip label="This is helpful.">
                <ActionIcon
                    className={classes.buttonThumbsUp}
                    aria-label={"This summary was useful"}
                    id="thumbs-up"
                    data-plum-id="personalized-summary-thumbs-up"
                    onClick={(event) => {
                        event.preventDefault()
                        handleFeedbackClick("positive")
                    }}
                    disabled={props.selectedFeedback === "positive"}
                >
                    <ThumbsUpFarFAIcon
                        filled={props.selectedFeedback === "positive"}
                        color={props.selectedFeedback === "positive" ? theme.colors.violet[5] : theme.colors.gray[7]}
                        size={16}
                    />
                </ActionIcon>
            </Tooltip>

            <Tooltip label="This is not helpful.">
                <ActionIcon
                    className={classes.buttonThumbsDown}
                    aria-label={"This summary was not useful"}
                    id="thumbs-down"
                    data-plum-id="personalized-summary-thumbs-down"
                    onClick={(event) => {
                        event.preventDefault()
                        handleFeedbackClick("negative")
                    }}
                    disabled={props.selectedFeedback === "negative"}
                >
                    <ThumbsDownFarFAIcon
                        filled={props.selectedFeedback === "negative"}
                        color={props.selectedFeedback === "negative" ? theme.colors.violet[5] : theme.colors.gray[7]}
                        size={16}
                    />
                </ActionIcon>
            </Tooltip>

            <Divider className={classes.divider} orientation="vertical" />

            <CopyButton value={props.summary} timeout={2000}>
                {({ copied, copy }) => (
                    <Tooltip label={copied ? "Response copied" : "Copy response."}>
                        <ActionIcon
                            className={classes.copyButton}
                            color={copied ? "teal" : "gray"}
                            data-plum-id="copilot-2-copy"
                            onClick={(event) => {
                                copy()
                                event.preventDefault()
                            }}
                            aria-label={"Copy this message"}
                        >
                            {copied ? (
                                <CheckFarFAIcon color={theme.colors.gray[7]} size={16} />
                            ) : (
                                <CopyFarFAIcon color={theme.colors.gray[7]} size={16} />
                            )}
                        </ActionIcon>
                    </Tooltip>
                )}
            </CopyButton>
        </Box>
    )
}
